require('./bootstrap');

(function ($) {
  $(document).ready(function () {
    let TopNav = require('./modules/top-nav.js');
    let Testimonials = require('./modules/testimonials.js');
    let TreeHouses = require('./modules/tree-houses.js');
    let Gallery = require('./modules/gallery');
    let Contacts = require('./modules/pages/contacts.js');
    let CollapseToggler = require('./modules/collapse-toggler.js');
    let Theme = require('./modules/theme.js');
    // let DatePicker = require('./modules/datepicker.js');
    let Activities = require('./modules/pages/activities');

    TopNav.init();
    Testimonials.init();
    TreeHouses.init();
    Gallery.init();
    Contacts.init();
    CollapseToggler.init();
    Theme.init();
    // DatePicker.init();
    Activities.init();

  });
})(window.jQuery);
